module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921044149_T.c769a38b.jpg";